(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["performance-profile"] && !Shopify.designMode) return;
  try {
    /*
    The Performance Profile column's reveal.

    The bar is measured by the same trick as blocks/tech-specs.liquid, and for
    the same reason — the reasoning is there.

    One loop drives every dot in the column, and that is the key decision here.
    The storyboard (`1562-16739`, "numbers move in to their position, left to
    right") and the client's brief describe one mechanism: the dots set off
    together from 1, travel at a shared speed, and each stops when it reaches
    its score. So what moves is not five animations of different durations but
    one shared mark that each dot clips with its own value — then the "3" stops
    first, the "9" last, and until each stop they run neck and neck. Different
    durations cannot reproduce that: every row would have a speed of its own.

    The digit in the dot is not a separate counter but that same mark, rounded.
    Position and label have one source, so they cannot drift apart.

    The speed is five divisions per second and stays even nearly all the way. An
    ordinary ease-out was tried here and rejected on the measurements: with it
    the dots crossed the first divisions three times faster than the average
    speed, 1-2-3 blurred together and the last ones crawled. The travel only
    accelerates — a short 18% ramp, then constant speed to the stop. The digit
    then changes every 200ms and can be read, and "stopped on its own number"
    looks like a stop rather than a fade.

    Five rather than nine: at nine the client could not tell what was happening
    at all — the longest row was over in a second. The digits matter more than
    the speed: if they cannot be read, the whole idea is pointless.

    The loop lives exactly as long as the travel and then dies; the theme
    subscribes to no scroll (see Theme.revealOnScroll).
  */
  const PROFILE_SPEED = 5; // divisions per second at the steady speed
  const PROFILE_RAMP = 0.18; // share of the time spent accelerating
  const PROFILE_DELAY = 650; // ms: the dots set off once the lines are drawn

  class PerformanceProfile extends HTMLElement {
    connectedCallback() {
      this.measurePlate();

      if (document.fonts) {
        document.fonts.ready.then(() => this.measurePlate());
      }

      Theme.revealOnScroll(this, () => this.play());
    }

    disconnectedCallback() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    measurePlate() {
      const plate = this.querySelector('.performance-profile__title');
      if (!plate) return;

      const range = document.createRange();
      range.selectNodeContents(plate);
      const text = range.getBoundingClientRect().width;
      if (!text) return;

      const styles = getComputedStyle(plate);
      const padding = parseFloat(styles.paddingInlineStart) + parseFloat(styles.paddingInlineEnd);

      plate.style.setProperty('--plate-width', `${Math.ceil(text + padding)}px`);
    }

    play() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      /*
        The scale's travel in pixels — its width less the dot's diameter: the
        very figure CSS works the resting position out from. Measured once, here,
        because before the reveal the column may not have been laid out yet.
      */
      const runs = Array.from(this.querySelectorAll('[data-score]'))
        .map((dot) => ({
          dot: dot,
          label: dot.textContent,
          score: Math.min(Math.max(parseFloat(dot.dataset.score) || 1, 1), 10),
          travel: dot.parentElement.clientWidth - dot.offsetWidth,
        }))
        .filter((run) => run.travel > 0);

      const last = runs.reduce((top, run) => Math.max(top, run.score), 1);
      if (runs.length === 0 || last <= 1) return;

      /*
        The ramp covers half of its share of the distance, so the steady speed
        is higher than the average — the duration is worked out from the steady
        one rather than the average, or PROFILE_SPEED would not mean what it
        says.
      */
      const reach = 1 - PROFILE_RAMP / 2;
      const duration = ((last - 1) / (PROFILE_SPEED * reach)) * 1000;

      // Put every dot on 1 before any of them fades in.
      runs.forEach((run) => this.place(run, 1));

      const started = performance.now();

      const step = (now) => {
        const elapsed = now - started - PROFILE_DELAY;
        const progress = Math.min(Math.max(elapsed / duration, 0), 1);
        const covered =
          progress < PROFILE_RAMP
            ? (progress * progress) / (2 * PROFILE_RAMP)
            : PROFILE_RAMP / 2 + (progress - PROFILE_RAMP);
        const mark = 1 + (last - 1) * (covered / reach);

        runs.forEach((run) => this.place(run, Math.min(run.score, mark)));

        if (progress < 1) {
          this.frame = requestAnimationFrame(step);
          return;
        }

        /*
          End of travel: the position goes back to CSS and the label back to
          the server-rendered markup. A merchant's score may be fractional, and
          the rounded mark then does not equal it — what has to be left on
          screen is what they entered.
        */
        runs.forEach((run) => {
          run.dot.style.removeProperty('--travel');
          run.dot.textContent = run.label;
        });

        this.frame = null;
      };

      this.frame = requestAnimationFrame(step);
    }

    place(run, mark) {
      run.dot.style.setProperty('--travel', `${((mark - run.score) / 10) * run.travel}px`);
      run.dot.textContent = String(Math.round(mark));
    }
  }

  if (!customElements.get('performance-profile')) {
    customElements.define('performance-profile', PerformanceProfile);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tech-specs"] && !Shopify.designMode) return;
  try {
    /*
    The table's reveal on scroll. All the movement lives in CSS; the two things
    a stylesheet cannot do are both in assets/theme.js, because the home page's
    feature section now makes the same movement and neither of them should own
    it: Theme.measurePlate writes the width of the bar's own line of text onto
    the bar, and Theme.revealOnScroll says when.
  */
  class TechSpecs extends HTMLElement {
    connectedCallback() {
      Theme.measurePlate(this.querySelector('.tech-specs__title'));
      Theme.revealOnScroll(this);
    }
  }

  if (!customElements.get('tech-specs')) {
    customElements.define('tech-specs', TechSpecs);
  }
  } catch(e) { console.error(e); }
})();

})();
